import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import "./resources/css/styles.css"
import { BrowserRouter } from 'react-router-dom'
//redux imports
import { Provider } from 'react-redux'
import store from "./store/store";

import Routes from './Routes';

axios.defaults.baseURL = 'https://laundryq.swedencentral.cloudapp.azure.com/finkaapp'
axios.defaults.withCredentials = true

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>, document.getElementById('root'));